import { DropdownItem } from "@atlaskit/dropdown-menu";
import OfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import { Inline } from "@atlaskit/primitives-next";

import { CustomerDomainOrg } from "@/components/fastshift/src/state/types";

import { useDashboardUIAnalytics } from "../../hooks";
import { OrgSelectorItemMessage } from "../org-selector-item-message";

export const OrgSelectorDropdownItem = ({
    org,
    isSelected,
    onSetSelectedDomainOrg
}: {
    org: CustomerDomainOrg;
    isSelected: boolean;
    onSetSelectedDomainOrg: (org: CustomerDomainOrg) => void;
}) => {
    const { sendOrgSelectorDropdownItemClickUIEvent } =
        useDashboardUIAnalytics();

    return (
        <DropdownItem
            key={org.orgId}
            isSelected={isSelected}
            onClick={() => {
                sendOrgSelectorDropdownItemClickUIEvent(org.orgId);
                onSetSelectedDomainOrg(org);
            }}
        >
            <Inline space="space.100" alignBlock="center">
                <OfficeBuildingIcon label="Org Icon" />
                <OrgSelectorItemMessage org={org} />
            </Inline>
        </DropdownItem>
    );
};
